import { render, staticRenderFns } from "./androdH5Mid.vue?vue&type=template&id=5c90b452"
import script from "./androdH5Mid.vue?vue&type=script&lang=js"
export * from "./androdH5Mid.vue?vue&type=script&lang=js"
import style0 from "./androdH5Mid.vue?vue&type=style&index=0&id=5c90b452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports